var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
export var Roles;
(function (Roles) {
    Roles["CareProvider"] = "group:compass:care_provider";
    Roles["MedManager"] = "group:compass:med_manager";
    Roles["Coach"] = "group:compass:coach";
    Roles["CareNavigator"] = "group:compass:care_navigator";
    Roles["CareSupportCoordinator"] = "group:compass:care_support_coordinator";
    Roles["Admin"] = "group:compass:admin";
    Roles["ClinicalManager"] = "group:compass:clinical_manager";
    Roles["ClinicalSupport"] = "group:compass:clinical_support";
    Roles["SuperAdmin"] = "group:compass:super_admin";
    Roles["BillingSpecialist"] = "group:compass:billing_specialist";
})(Roles || (Roles = {}));
// row numbers below reference this sheet:
// https://docs.google.com/spreadsheets/d/15lOXc8S4Jrc26oDDQZ-5v6D6jPnSZVncEGDPMdf1rLU/edit#gid=419734157
/** Things permissions will be applied to */
export var Subjects;
(function (Subjects) {
    Subjects["DemographicsAllMembers"] = "notes:demographics:allMembers";
    Subjects["DemographicsMyMembers"] = "notes:demographics:myMembers";
    Subjects["NotesAllNotes"] = "notes:notes:allNotes";
    Subjects["NotesMyNotes"] = "notes:notes:myNotes";
    /**
     * Signed notes
     *
     * [Actions.View]: Can view notes that other providers have signed
     */
    Subjects["NotesSignedNotes"] = "notes:notes:signedNotes";
    /**
     * Interactions with members
     *
     * [Actions.View]: Can view interactions with members
     */
    Subjects["InteractionsAllInteractions"] = "notes:interactions:allMembers";
    /**
     * Members' assessments
     *
     * [Actions.View]: Can view assessments members have taken
     */
    Subjects["AssessmentsAllAssessments"] = "notes:assessments:allMembers";
    Subjects["SearchMyMembers"] = "scheduling:search:myMembers";
    Subjects["SearchAllMembers"] = "scheduling:search:allMembers";
    Subjects["SearchAllCaregivers"] = "scheduling:search:allCaregivers";
    Subjects["AppointmentsAllAppointments"] = "scheduling:appointments:allAppointments";
    Subjects["AppointmentsMyAppointments"] = "scheduling:appointments:myAppointments";
    Subjects["AppointmentsMyCalendar"] = "scheduling:appointments:myCalendar";
    Subjects["AppointmentsAllCalendars"] = "scheduling:appointments:allCalendars";
    Subjects["AppointmentsMyAvailability"] = "scheduling:appointments:myAvailability";
    Subjects["AppointmentsAllAvailability"] = "scheduling:appointments:allAvailability";
    Subjects["AppointmentsConfirmationEmails"] = "scheduling:appointments:confirmationEmails";
    Subjects["AppointmentsMyTimezone"] = "scheduling:appointments:myTimezone";
    Subjects["AppointmentsAllTimezones"] = "scheduling:appointments:allTimezones";
    /**
     * Hide appointments by submitting issues
     *
     * [Actions.Edit]: Can hide appointments by submitting issues from interactions page
     */
    Subjects["AppointmentsHideAppointments"] = "scheduling:appointments:hideAppointments";
    Subjects["AdministrativeCnCaseload"] = "scheduling:administrative:cnCaseload";
    Subjects["AdministrativeMyNewPatientHold"] = "scheduling:administrative:myNewPatientHold";
    Subjects["AdministrativeAllNewPatientHold"] = "scheduling:administrative:allNewPatientHold";
    Subjects["AdministrativeAppointmentType"] = "scheduling:administrative:appointmentType";
    Subjects["UsersAllUsers"] = "compass:users:allUsers";
    /**
     * Unscheduled interactions on your assigned members
     *
     * [Actions.Edit]: Can create unscheduled interactions on your assigned members
     */
    Subjects["UnscheduledInteractionsMyMembers"] = "notes:unscheduledInteractions:myMembers";
    /**
     * Unscheduled interactions on your assigned members
     *
     * [Actions.Edit]: Can create unscheduled interactions on any member
     */
    Subjects["UnscheduledInteractionsAllMembers"] = "notes:unscheduledInteractions:allMembers";
    Subjects["UsersMyUser"] = "compass:users:myUser";
    /**
     * Documents (viewing a client)
     *
     * [Actions.View]: Can download/view documents assigned to client
     * [Actions.Edit]: Can upload/delete documents assigned to the client
     */
    Subjects["DocumentsAllDocuments"] = "documents:allDocuments";
    Subjects["DocumentsMyDocuments"] = "documents:myDocuments";
    Subjects["DocumentsBillingDocuments"] = "documents:billingDocuments";
    Subjects["UserInternalUser"] = "compass:user:internalUser";
    /**
     * Member Search
     * [Actions.View] Can see the clients side nav bar and actual member search table
     *
     */
    Subjects["ClientsMyClients"] = "clients:myClients";
    Subjects["ClientsAllClients"] = "clients:allClients";
    /**
     * Medications
     * [Actions.Edit] Can access the DoseSpot iframe
     */
    Subjects["PrescriptionsMyMembers"] = "prescriptions:myMembers";
    Subjects["PrescriptionsAllMembers"] = "prescriptions:allMembers";
    /**
     * Acuity Calendar Sync
     * [Actions.Edit] Can edit the 'Show external calendar events in Compass' Toggle in user settings
     */
    Subjects["UsersAcuityCalendarSyncSettings"] = "compass:users:acuityCalendarSync";
    /**
     * MBC Push Notifications
     * [Actions.Edit] Can request new questionnaires
     */
    Subjects["MbcPushNotificationsAllMembers"] = "mbc:pushNotifications:allMembers";
})(Subjects || (Subjects = {}));
/** Things that can be done to 'Subjects' */
export var Actions;
(function (Actions) {
    Actions["View"] = "view";
    /** edit, (implied create and maybe delete in some cases?) */
    Actions["Edit"] = "edit";
})(Actions || (Actions = {}));
export var compassUserPermissions = (_a = {},
    _a[Roles.CareProvider] = (_b = {},
        _b[Subjects.AdministrativeMyNewPatientHold] = [Actions.View, Actions.Edit],
        _b[Subjects.AppointmentsMyAppointments] = [Actions.View, Actions.Edit],
        _b[Subjects.AppointmentsMyCalendar] = [Actions.View, Actions.Edit],
        _b[Subjects.AppointmentsMyAvailability] = [Actions.View, Actions.Edit],
        _b[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _b[Subjects.AppointmentsMyTimezone] = [Actions.View, Actions.Edit],
        _b[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _b[Subjects.ClientsMyClients] = [Actions.View],
        _b[Subjects.DemographicsAllMembers] = [Actions.View],
        _b[Subjects.DemographicsMyMembers] = [Actions.View, Actions.Edit],
        _b[Subjects.DocumentsMyDocuments] = [Actions.View, Actions.Edit],
        _b[Subjects.InteractionsAllInteractions] = [Actions.View],
        _b[Subjects.NotesAllNotes] = [Actions.View],
        _b[Subjects.NotesMyNotes] = [Actions.View, Actions.Edit],
        _b[Subjects.PrescriptionsMyMembers] = [Actions.View],
        _b[Subjects.SearchMyMembers] = [Actions.View],
        _b[Subjects.SearchAllMembers] = [Actions.View],
        _b[Subjects.UnscheduledInteractionsAllMembers] = [Actions.Edit],
        _b[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _b[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _b[Subjects.UserInternalUser] = [Actions.View],
        _b[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _b),
    _a[Roles.MedManager] = (_c = {},
        _c[Subjects.AdministrativeMyNewPatientHold] = [Actions.View, Actions.Edit],
        _c[Subjects.AppointmentsMyAppointments] = [Actions.View, Actions.Edit],
        _c[Subjects.AppointmentsMyCalendar] = [Actions.View, Actions.Edit],
        _c[Subjects.AppointmentsMyAvailability] = [Actions.View, Actions.Edit],
        _c[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _c[Subjects.AppointmentsMyTimezone] = [Actions.View, Actions.Edit],
        _c[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _c[Subjects.ClientsMyClients] = [Actions.View],
        _c[Subjects.DemographicsAllMembers] = [Actions.View],
        _c[Subjects.DemographicsMyMembers] = [Actions.View, Actions.Edit],
        _c[Subjects.DocumentsMyDocuments] = [Actions.View, Actions.Edit],
        _c[Subjects.InteractionsAllInteractions] = [Actions.View],
        _c[Subjects.NotesMyNotes] = [Actions.View, Actions.Edit],
        _c[Subjects.NotesSignedNotes] = [Actions.View],
        _c[Subjects.PrescriptionsMyMembers] = [Actions.View, Actions.Edit],
        _c[Subjects.SearchMyMembers] = [Actions.View],
        _c[Subjects.SearchAllMembers] = [Actions.View],
        _c[Subjects.UserInternalUser] = [Actions.View],
        _c[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _c[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _c[Subjects.UnscheduledInteractionsAllMembers] = [Actions.Edit],
        _c[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _c),
    _a[Roles.Coach] = (_d = {},
        _d[Subjects.AppointmentsMyCalendar] = [Actions.View, Actions.Edit],
        _d[Subjects.AppointmentsMyAvailability] = [Actions.View, Actions.Edit],
        _d[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _d[Subjects.AppointmentsMyTimezone] = [Actions.View, Actions.Edit],
        _d[Subjects.ClientsMyClients] = [Actions.View],
        _d[Subjects.DemographicsMyMembers] = [Actions.View, Actions.Edit],
        _d[Subjects.DocumentsMyDocuments] = [Actions.View, Actions.Edit],
        _d[Subjects.SearchMyMembers] = [Actions.View],
        _d[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _d[Subjects.UserInternalUser] = [Actions.View],
        _d[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _d),
    _a[Roles.CareNavigator] = (_e = {},
        _e[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsMyAppointments] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsMyCalendar] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsMyAvailability] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsMyTimezone] = [Actions.View, Actions.Edit],
        _e[Subjects.AppointmentsAllTimezones] = [Actions.View, Actions.Edit],
        _e[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _e[Subjects.ClientsMyClients] = [Actions.View],
        _e[Subjects.ClientsAllClients] = [Actions.View],
        _e[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _e[Subjects.DemographicsMyMembers] = [Actions.View, Actions.Edit],
        _e[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _e[Subjects.InteractionsAllInteractions] = [Actions.View, Actions.Edit],
        _e[Subjects.NotesMyNotes] = [Actions.View, Actions.Edit],
        _e[Subjects.NotesSignedNotes] = [Actions.View],
        _e[Subjects.PrescriptionsMyMembers] = [Actions.View],
        _e[Subjects.SearchMyMembers] = [Actions.View],
        _e[Subjects.SearchAllMembers] = [Actions.View],
        _e[Subjects.SearchAllCaregivers] = [Actions.View],
        _e[Subjects.UnscheduledInteractionsAllMembers] = [Actions.Edit],
        _e[Subjects.UsersAllUsers] = [Actions.View],
        _e[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _e[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _e[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _e),
    _a[Roles.CareSupportCoordinator] = (_f = {},
        _f[Subjects.AdministrativeAllNewPatientHold] = [Actions.View, Actions.Edit],
        _f[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _f[Subjects.AppointmentsAllCalendars] = [Actions.View, Actions.Edit],
        _f[Subjects.AppointmentsAllAvailability] = [Actions.View, Actions.Edit],
        _f[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _f[Subjects.ClientsAllClients] = [Actions.View],
        _f[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _f[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _f[Subjects.InteractionsAllInteractions] = [Actions.View, Actions.Edit],
        _f[Subjects.NotesSignedNotes] = [Actions.View],
        _f[Subjects.PrescriptionsAllMembers] = [Actions.View, Actions.Edit],
        _f[Subjects.SearchAllMembers] = [Actions.View],
        _f[Subjects.SearchAllCaregivers] = [Actions.View],
        _f[Subjects.UsersAllUsers] = [Actions.View],
        _f[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _f[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _f),
    _a[Roles.Admin] = (_g = {},
        _g[Subjects.AdministrativeCnCaseload] = [Actions.View, Actions.Edit],
        _g[Subjects.AdministrativeAllNewPatientHold] = [Actions.View, Actions.Edit],
        _g[Subjects.AdministrativeAppointmentType] = [Actions.View, Actions.Edit],
        _g[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _g[Subjects.AppointmentsAllAvailability] = [Actions.View, Actions.Edit],
        _g[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _g[Subjects.AppointmentsHideAppointments] = [Actions.Edit],
        _g[Subjects.ClientsAllClients] = [Actions.View],
        _g[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _g[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _g[Subjects.InteractionsAllInteractions] = [Actions.View],
        _g[Subjects.PrescriptionsAllMembers] = [Actions.View, Actions.Edit],
        _g[Subjects.SearchAllMembers] = [Actions.View],
        _g[Subjects.SearchAllCaregivers] = [Actions.View],
        _g[Subjects.UsersAllUsers] = [Actions.View, Actions.Edit],
        _g[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _g[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _g),
    _a[Roles.ClinicalManager] = (_h = {},
        _h[Subjects.AdministrativeCnCaseload] = [Actions.View, Actions.Edit],
        _h[Subjects.AdministrativeAllNewPatientHold] = [Actions.View, Actions.Edit],
        _h[Subjects.AdministrativeAppointmentType] = [Actions.View, Actions.Edit],
        _h[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _h[Subjects.AppointmentsAllAvailability] = [Actions.View, Actions.Edit],
        _h[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _h[Subjects.AppointmentsHideAppointments] = [Actions.Edit],
        _h[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _h[Subjects.ClientsAllClients] = [Actions.View],
        _h[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _h[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _h[Subjects.InteractionsAllInteractions] = [Actions.View, Actions.Edit],
        _h[Subjects.NotesSignedNotes] = [Actions.View],
        _h[Subjects.PrescriptionsAllMembers] = [Actions.View, Actions.Edit],
        _h[Subjects.SearchAllMembers] = [Actions.View],
        _h[Subjects.SearchAllCaregivers] = [Actions.View],
        _h[Subjects.UnscheduledInteractionsAllMembers] = [Actions.Edit],
        _h[Subjects.UsersAllUsers] = [Actions.View, Actions.Edit],
        _h[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _h[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _h),
    _a[Roles.ClinicalSupport] = (_j = {},
        _j[Subjects.AdministrativeAllNewPatientHold] = [Actions.View, Actions.Edit],
        _j[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _j[Subjects.AppointmentsAllAvailability] = [Actions.View, Actions.Edit],
        _j[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _j[Subjects.AppointmentsHideAppointments] = [Actions.Edit],
        _j[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _j[Subjects.ClientsAllClients] = [Actions.View],
        _j[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _j[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _j[Subjects.InteractionsAllInteractions] = [Actions.View],
        _j[Subjects.NotesSignedNotes] = [Actions.View],
        _j[Subjects.SearchAllMembers] = [Actions.View],
        _j[Subjects.SearchAllCaregivers] = [Actions.View],
        _j[Subjects.UsersAllUsers] = [Actions.View, Actions.Edit],
        _j[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _j[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _j[Subjects.PrescriptionsAllMembers] = [Actions.View, Actions.Edit],
        _j),
    _a[Roles.SuperAdmin] = (_k = {},
        _k[Subjects.AdministrativeCnCaseload] = [Actions.View, Actions.Edit],
        _k[Subjects.AdministrativeAllNewPatientHold] = [Actions.View, Actions.Edit],
        _k[Subjects.AdministrativeAppointmentType] = [Actions.View, Actions.Edit],
        _k[Subjects.AppointmentsAllAppointments] = [Actions.View, Actions.Edit],
        _k[Subjects.AppointmentsAllAvailability] = [Actions.View, Actions.Edit],
        _k[Subjects.AppointmentsConfirmationEmails] = [Actions.View, Actions.Edit],
        _k[Subjects.AppointmentsHideAppointments] = [Actions.Edit],
        _k[Subjects.AssessmentsAllAssessments] = [Actions.View],
        _k[Subjects.ClientsAllClients] = [Actions.View],
        _k[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _k[Subjects.DocumentsAllDocuments] = [Actions.View, Actions.Edit],
        _k[Subjects.InteractionsAllInteractions] = [Actions.View, Actions.Edit],
        // [Subjects.NotesAllNotes]: [Actions.View, Actions.Edit], //will have view/edit all note capabilities later
        _k[Subjects.NotesSignedNotes] = [Actions.View],
        _k[Subjects.PrescriptionsAllMembers] = [Actions.View, Actions.Edit],
        _k[Subjects.SearchAllMembers] = [Actions.View],
        _k[Subjects.SearchAllCaregivers] = [Actions.View],
        _k[Subjects.UsersAllUsers] = [Actions.View, Actions.Edit],
        _k[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _k[Subjects.UsersAcuityCalendarSyncSettings] = [Actions.Edit],
        _k[Subjects.MbcPushNotificationsAllMembers] = [Actions.View, Actions.Edit],
        _k),
    _a[Roles.BillingSpecialist] = (_l = {},
        _l[Subjects.AppointmentsAllAppointments] = [Actions.View],
        _l[Subjects.ClientsAllClients] = [Actions.View],
        _l[Subjects.DemographicsAllMembers] = [Actions.View, Actions.Edit],
        _l[Subjects.InteractionsAllInteractions] = [Actions.View],
        _l[Subjects.NotesSignedNotes] = [Actions.View],
        _l[Subjects.SearchAllMembers] = [Actions.View],
        _l[Subjects.SearchAllCaregivers] = [Actions.View],
        _l[Subjects.UsersMyUser] = [Actions.View, Actions.Edit],
        _l[Subjects.DocumentsBillingDocuments] = [Actions.View],
        _l),
    _a);
